(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.initCarousel();

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const slide = event.target.closest('[data-slide-index]');
        if (slide) this.showSlide(Number(slide.dataset.slideIndex), { announce: false });
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.abortController?.abort();
    }

    initCarousel() {
      this.slides = Array.from(this.querySelectorAll('.kit-shoppable-hero__slide'));
      if (this.slides.length < 2) return;

      const signal = this.abortController.signal;
      this.currentIndex = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.viewport = this.querySelector('.kit-shoppable-hero__viewport');
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverCapable = window.matchMedia('(hover: hover)').matches;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && !Shopify.designMode;
      this.autoplaySpeed = Math.max(3000, Number(this.dataset.autoplaySpeed) || 6000);
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';

      this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex - 1, { userInitiated: true });
      }, { signal });

      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex + 1, { userInitiated: true });
      }, { signal });

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.showSlide(Number(dot.dataset.carouselDot), { userInitiated: true });
        }, { signal });
      });

      this.viewport?.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showSlide(this.currentIndex - 1, { userInitiated: true });
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showSlide(this.currentIndex + 1, { userInitiated: true });
        }
      }, { signal });

      this.viewport?.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.target.closest('a, button, input, select, textarea, [role="button"]')) return;
        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
      }, { signal });

      this.viewport?.addEventListener('pointerup', event => {
        if (event.pointerId !== this.pointerId || this.pointerStartX == null) return;
        const distance = event.clientX - this.pointerStartX;
        this.pointerId = null;
        this.pointerStartX = null;
        if (Math.abs(distance) < 40) return;
        this.showSlide(this.currentIndex + (distance < 0 ? 1 : -1), { userInitiated: true });
      }, { signal });

      this.viewport?.addEventListener('pointercancel', () => {
        this.pointerId = null;
        this.pointerStartX = null;
      }, { signal });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stopAutoplay(), { signal });
        this.addEventListener('mouseleave', () => this.startAutoplay(), { signal });
      }
      this.addEventListener('focusin', () => this.stopAutoplay(), { signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      }, { signal });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      }, { signal });

      this.reducedMotion.addEventListener?.('change', () => {
        if (this.reducedMotion.matches) this.stopAutoplay();
        else this.startAutoplay();
      }, { signal });

      this.showSlide(this.currentIndex, { announce: false });
      this.startAutoplay();
    }

    showSlide(index, options = {}) {
      if (!this.slides?.length) return;
      const nextIndex = (index + this.slides.length) % this.slides.length;
      const announce = options.announce !== false;

      this.querySelectorAll('kit-popover:popover-open').forEach(popover => popover.hidePopover?.());
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
      });

      this.dots?.forEach((dot, dotIndex) => {
        const active = dotIndex === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      this.currentIndex = nextIndex;
      if (announce) {
        const status = this.querySelector('[data-carousel-status]');
        if (status) status.textContent = this.slides[nextIndex].getAttribute('aria-label') || '';
      }

      if (options.userInitiated) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || this.reducedMotion?.matches || document.hidden || (this.pauseOnHover && this.hoverCapable && this.matches(':hover')) || this.contains(document.activeElement)) return;
      const autoplayDelay = this.autoplaySpeed;
      this.autoplayTimer = window.setTimeout(() => {
        this.showSlide(this.currentIndex + 1, { announce: false });
        this.startAutoplay();
      }, autoplayDelay);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  if (!customElements.get('kit-shoppable-hero')) {
    customElements.define('kit-shoppable-hero', KitShoppableHero);
  }

  } catch(e) { console.error(e); }
})();
})();
